function getParsedJwt(token) {
    try {
        return JSON.parse(atob(token.split('.')[1]));
    }
    catch (_a) {
        return undefined;
    }
}
export function jwtDoesNotContainText(jwt, text) {
    return !JSON.stringify(getParsedJwt(jwt)).includes(text);
}
//# sourceMappingURL=decodeJwt.js.map